var map = {
	"./animatedScroll.js": 60895,
	"./footer.js": 57019,
	"./layouts/burgerMenu.js": 71962,
	"./layouts/main.js": 16269,
	"./lottieLogo.js": 11895,
	"./slider.js": 22811
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21331;